import { z } from "zod";
import { GenericFoodSchema } from "./FoodSchema";
export const CompassFoodSchema = GenericFoodSchema.merge(z.object({
    source: z.literal("compass"),
    compassMasterRefNumber: z.string(),
}));
//# sourceMappingURL=CompassFoodSchema.js.map